import { useMemo } from 'react';
import { useSelector } from 'react-redux';

function useCreateSelector(inputSelector, resultFunc) {
  const inputValue = useSelector(inputSelector);
  return useMemo(() => resultFunc(inputValue), [inputValue]); // eslint-disable-line react-hooks/exhaustive-deps
}

export default useCreateSelector;
